<template>
  <div id="error-table">
    <b-form inline class="justify-content-end">
      <div class="input-group input-group-sm">
        <input
          class="form-control input-search bg-grey1"
          type="search"
          v-model="filter"
          placeholder="Search"
          id="filterInput"
          aria-label="Search"
        />
        <div class="input-group-append">
          <div class="btn btn-navbar input-search">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="19"
              viewBox="0 0 35 34.12"
            >
              <path
                id="icon_search"
                data-name="icon search"
                d="M889.127,345a10.478,10.478,0,1,0-10.446-10.5A10.509,10.509,0,0,0,889.127,345ZM910.08,351.6v.114l-3.176,2.862-8.732-9.244a14.236,14.236,0,1,1,2.173-2.291q4.8,4.234,9.592,8.473A.965.965,0,0,0,910.08,351.6Z"
                transform="translate(-875.08 -320.451)"
                fill="#008995"
              />
            </svg>
          </div>
        </div>
      </div>
    </b-form>
    <b-table
      id="error-btable"
      class="table table-light btable"
      hover
      selectable
      :items="loadData"
      :fields="ErrorFields"
      :per-page="perPage"
      :current-page="currentPage"
      :no-provider-sorting="true"
      :select-mode="selectMode"
      :filter="filter"
      :filterIncludedFields="filterOn"
      @filtered="onFiltered"
    >
      <template v-slot:cell(delete_checkbox)="data">
        <input
          type="checkbox"
          v-model="delete_ids"
          class="del-checkbox"
          :value="data.item.id"
        />
      </template>
      <!-- <template v-slot:cell(sheet_name)="data">
        {{data.item.question.projectsheet.sheet_name}}
      </template> -->
      <!-- <template v-slot:cell(question_no)="data">
        {{data.item.question.question_id}}
      </template> -->
      <!-- <template v-slot:cell(username)="data">
        {{data.item.user.name}}
      </template> -->
    </b-table>
    <div class="form-row">
      <div class="col mb-1">
        <b-button-group class="mx-1">
          <b-button
            size="sm"
            :disabled="delete_ids.length == 0"
            variant="outline-primary"
            class="fas fa-minus"
            @click="deleteError()"
            v-b-popover.hover.top="'Delete'"
          ></b-button>
        </b-button-group>
      </div>
      <div class="col mb-1 mr-5 d-flex justify-content-between">
        <b-pagination
          v-model="currentPage"
          :limit="10"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      filter: null,
      selectMode: "single",
      errors: [],
      ErrorFields: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      currentRows: 0,
      filterOn: [],
      delete_ids: [],
    };
  },
  watch: {
    status: function (newVal, oldVal) {
      this.$root.$emit("bv::refresh::table", "error-btable");
    },
  },
  methods: {
    loadData(ctx, callback) {
      request({
        url: "api/error/getdata",
        method: "post",
        data: {
          page: ctx.currentPage,
          size: ctx.perPage,
          filter: ctx.filter,
        },
      })
        .then((data) => {
          if (data.errors) {
            this.currentRows = data.errors.length;
          }
          this.errors = data.errors;
          this.totalRows = data.totalRows;
          this.setFieldsForTable();
          callback(data.errors);
          this.$emit("stopPreloader", false);
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
        });
    },
    setFieldsForTable() {
      this.ErrorFields.push({
        delete_checkbox: { label: "", sortable: false, class: "w-5" },
      });
      this.ErrorFields.push({
        sheet_name: { label: "Sheet", sortable: true, class: "w-15" },
      });
      this.ErrorFields.push({
        question_no: { label: "No", sortable: true, class: "w-20" },
      });
      this.ErrorFields.push({
        username: { label: "User", sortable: true, class: "w-15" },
      });
      this.ErrorFields.push({
        error_msg: { label: "Error", sortable: true, class: "w-25" },
      });
      this.ErrorFields.push({
        exception: { label: "Exception", sortable: true, class: "w-25" },
      });
      this.ErrorFields.push({
        created_at: { label: "Date", sortable: true, class: "w-20-center" },
      });
    },
    deleteError() {
      var count = this.delete_ids.length;
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "Do you want to remove  " + count + " Error's!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            request({
              url: "api/error/destroy",
              method: "DELETE",
              data: {
                delete_ids: this.delete_ids,
              },
            })
              .then((data) => {
                if (data.status === true) {
                  this.$root.$emit("bv::refresh::table", "error-btable");
                  this.$swal
                    .mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 3000,
                    })
                    .fire("Deleted", data.message, "success");
                  this.delete_ids = [];
                } else {
                  this.$swal.fire("Error!", data.message, "error");
                }
              })
              .catch(function (err) {
                console.log("Fetch Error :-S", err);
              });
          }
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>